import { render, staticRenderFns } from "./linkingLoginComponent.vue?vue&type=template&id=677266e8&scoped=true"
import script from "./linkingLoginComponent.vue?vue&type=script&lang=js"
export * from "./linkingLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./linkingLoginComponent.vue?vue&type=style&index=0&id=677266e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677266e8",
  null
  
)

export default component.exports